import React, { useState } from "react";
import "./Delete.css";

const Delete = (props) => {
  const [isDay] = useState(props.isDeleteDay);
  const [isActivity] = useState(props.isActivity ? props.isActivity : false);
  const [isAppointment] = useState(props.isAppointment ? props.isAppointment : false);

  return (
    <div className={"dlt_surround" + (isActivity ? " dlt_box" : "")}>
      <div className="dlt_title">Delete {isActivity ? "Exercise" : "Confirmation"}</div>
      {!isActivity && !isAppointment ? (
        <div className="dlt_description">
          <p>
            You are about to delete the selected <span>{isDay ? "Day" : isActivity ? "Exercise" : "Activity"}</span>.
          </p>
          <p>Please confirm your intent.</p>
        </div>
      ) : (
        <div className="dlt_description">
          <p>Do you want to delete this {isAppointment ? "appointment" : "exercise"}?</p>
        </div>
      )}
      <div className="dlt_exit_btm">
        <div className="dlt_exit_btn dlt_eb_first" onClick={() => props.dltDismiss(false)}>
          Cancel
        </div>
        <div className="dlt_exit_btn dlt_eb_scnd" onClick={() => props.dltDismiss(true)}>
          {isActivity ? "Delete" : "Confirm"}
        </div>
      </div>
    </div>
  );
};

export default Delete;
